export default __webpack_public_path__ + "static/media/logo-color.95316f77.png";